module.exports = __webpack_public_path__ + "static/img/zsl169h.5e29eb9e.jpg";